"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireWildcard(require("../Icon"));

var _utils = require("../../utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ExtraItem(_ref) {
  var icon = _ref.icon,
      isActive = _ref.isActive,
      onClick = _ref.onClick,
      children = _ref.children;
  var className = (0, _utils.getClassNames)('ant-tabs-extra__item', {
    'ant-tabs-extra__item_active': isActive
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, children || /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: icon,
    onClick: onClick
  }));
}

ExtraItem.propTypes = {
  isActive: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  icon: _propTypes.default.oneOf(_Icon.ICON_TYPES),
  children: _propTypes.default.node
};
ExtraItem.defaultProps = {
  isActive: false,
  onClick: function onClick() {},
  icon: null,
  children: null
};
var _default = ExtraItem;
exports.default = _default;